// extracted by mini-css-extract-plugin
export var blockBtn = "main-module--block-btn--c60f1";
export var blockTitle = "main-module--block-title--07b44";
export var blockTitleLg = "main-module--block-title-lg--96e7a";
export var blockTitleMd = "main-module--block-title-md--a29fb";
export var blockTitleMin = "main-module--block-title-min--02829";
export var blockTitleSm = "main-module--block-title-sm--b17dd";
export var fw500 = "main-module--fw-500--612a6";
export var fw900 = "main-module--fw-900--44697";
export var red = "main-module--red--9e25c";
export var sec = "main-module--sec--b61e9";
export var unline = "main-module--unline--b0f93";
export var unlineRed = "main-module--unline-red--5afb5";
export var unlineYellow = "main-module--unline-yellow--f45b6";
export var video = "main-module--video--60385";
export var videoWrap = "main-module--video-wrap--06c7c";